export enum ThemeColor {
    Red = 1,
    Pink,
    Orange,
    Green,
    DarkBlue,
    LightBlue,
    Purple,
    Grey,
}

export const primaryThemeColorByEnum = {
    [ThemeColor.Red]: '#b32925',
    [ThemeColor.Pink]: '#f8adaf',
    [ThemeColor.Orange]: '#f15922',
    [ThemeColor.Green]: '#98d2b3',
    [ThemeColor.DarkBlue]: '#2c5e7d',
    [ThemeColor.LightBlue]: '#78b5e3',
    [ThemeColor.Purple]: '#5d468c',
    [ThemeColor.Grey]: '#373c50',
};

export const secondaryThemeColorByEnum = {
    [ThemeColor.Red]: 'rgb(179, 41, 37, 0.2)',
    [ThemeColor.Pink]: 'rgb(248, 173, 175, 0.2)',
    [ThemeColor.Orange]: 'rgb(241, 89, 34, 0.2)',
    [ThemeColor.Green]: 'rgb(152, 210, 179, 0.2)',
    [ThemeColor.DarkBlue]: 'rgb(44, 94, 125, 0.2)',
    [ThemeColor.LightBlue]: 'rgb(120, 181, 227, 0.2)',
    [ThemeColor.Purple]: 'rgb(93, 70, 140, 0.2)',
    [ThemeColor.Grey]: 'rgb(55, 60, 80, 0.2)',
};
